import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router";

import "assets/scss/material-kit-pro-react.scss";

// pages for this product

import LandingPage from "views/LandingPage/LandingPage.jsx";
import AboutUsPage from "views/AboutUsPage/AboutUsPage.jsx";
import PrivacyPage from "views/PrivacyPage/PrivacyPage.jsx";
import BlogPost from "views/BlogPost/BlogPost.jsx";
import BlogPostsPage from "views/BlogPostsPage/BlogPostsPage.jsx";
import ContactUsPage from "views/ContactUsPage/ContactUsPage.jsx";

import BrokerPage from "views/BrokerPage/BrokerPage.jsx";
import InvestorsPage from "views/InvestorsPage/InvestorsPage.jsx";
import DevelopersPage from "views/DevelopersPage/DevelopersPage.jsx";
import RelationsPage from "views/RelationsPage/RelationsPage.jsx";
import MarketPage from "views/MarketPage/MarketPage.jsx";

import ServicesPage from "views/ServicesPage/ServicesPage.jsx";
import BuyingSellingPage from "views/services/BuyingSellingPage/BuyingSellingPage.jsx";
import NewDevelopmentsPage from "views/services/NewDevelopmentsPage/NewDevelopmentsPage.jsx";
import AssetsManagementPage from "views/services/AssetsManagementPage/AssetsManagementPage.jsx";
import FamilyOfficePage from "views/services/FamilyOfficePage/FamilyOfficePage.jsx";
import FinancePage from "views/services/FinancePage/FinancePage.jsx";
import InvestmentServicesPage from "views/services/InvestmentServicesPage/InvestmentServicesPage.jsx";
import ValuationPage from "views/services/ValuationPage/ValuationPage.jsx";
import ResearchPage from "views/services/ResearchPage/ResearchPage.jsx";
import DevelopmentPage from "views/services/DevelopmentPage/DevelopmentPage.jsx";

import PropertiesPage from "views/PropertiesPage/PropertiesPage.jsx";
import HotelsPage from "views/assets/HotelsPage/HotelsPage.jsx";
import Hotel from "views/assets/Hotel/Hotel.jsx";
import MallsPage from "views/assets/MallsPage/MallsPage.jsx";
import Mall from "views/assets/Mall/Mall.jsx";
import RetailPage from "views/assets/RetailPage/RetailPage.jsx";
import Retail from "views/assets/Retail/Retail.jsx";
import IndustrialPage from "views/assets/IndustrialPage/IndustrialPage.jsx";
import Industrial from "views/assets/Industrial/Industrial.jsx";
import OfficesPage from "views/assets/OfficesPage/OfficesPage.jsx";
import Office from "views/assets/Office/Office.jsx";
import ResidentialPage from "views/assets/ResidentialPage/ResidentialPage.jsx";
import Residential from "views/assets/Residential/Residential.jsx";
import RuralLandsPage from "views/assets/RuralLandsPage/RuralLandsPage.jsx";
import RuralLand from "views/assets/RuralLand/RuralLand.jsx";
import UrbanLandsPage from "views/assets/UrbanLandsPage/UrbanLandsPage.jsx";
import UrbanLand from "views/assets/UrbanLand/UrbanLand.jsx";
import BuildingsPage from "views/assets/BuildingsPage/BuildingsPage.jsx";
import Building from "views/assets/Building/Building.jsx";
import InvestmentsPage from "views/assets/InvestmentsPage/InvestmentsPage.jsx";
import Investment from "views/assets/Investment/Investment.jsx";
import SuplyOpsPage from "views/assets/SuplyOpsPage/SuplyOpsPage.jsx";
import SuplyOp from "views/assets/SuplyOp/SuplyOp.jsx";
import DemandOpsPage from "views/assets/DemandOpsPage/DemandOpsPage.jsx";
import DemandOp from "views/assets/DemandOp/DemandOp.jsx";
import NewDevelopmentPropertiesPage from "views/assets/NewDevelopmentsPage/NewDevelopmentsPage.jsx";
import NewDevelopmentProperty from "views/assets/NewDevelopment/NewDevelopment.jsx";

import RegisterPage from "views/RegisterPage/RegisterPage.jsx";

var hist = createBrowserHistory();

ReactDOM.render(
  <Router history={hist}>
    <Switch>


      <Route path="/contact-us" component={ContactUsPage} />
      <Route path="/about-us" component={AboutUsPage} />
      <Route path="/privacy" component={PrivacyPage} />
      <Route path="/blog-posts" component={BlogPostsPage} />
      <Route path="/blog-post/:id" component={BlogPost} />
      <Route path="/brokers" component={BrokerPage} />
      <Route path="/investors" component={InvestorsPage} />
      <Route path="/developers" component={DevelopersPage} />
      <Route path="/relations" component={RelationsPage} />

      <Route path="/services" component={ServicesPage} />
      <Route path="/buying-selling" component={BuyingSellingPage} />
      <Route path="/new-developments" component={NewDevelopmentsPage} />
      <Route path="/assets-management" component={AssetsManagementPage} />
      <Route path="/family-office" component={FamilyOfficePage} />
      <Route path="/finance" component={FinancePage} />
      <Route path="/investment-services" component={InvestmentServicesPage} />
      <Route path="/valuation" component={ValuationPage} />
      <Route path="/research" component={ResearchPage} />
      <Route path="/development" component={DevelopmentPage} />

      <Route path="/properties" component={PropertiesPage} />
      <Route path="/hotels" component={HotelsPage} />
      <Route path="/hotel/:id" component={Hotel} />
      <Route path="/malls" exact component={MallsPage} />
      <Route path="/mall/:id" component={Mall} />
      <Route path="/retail" exact component={RetailPage} />
      <Route path="/retail/:id?" component={Retail} />
      <Route path="/industrial" exact component={IndustrialPage} />
      <Route path="/industrial/:id?" component={Industrial} />
      <Route path="/offices" exact component={OfficesPage} />
      <Route path="/office/:id?" component={Office} />
      <Route path="/residential" exact component={ResidentialPage} />
      <Route path="/residential/:id?" component={Residential} />
      <Route path="/new_development_properties" component={NewDevelopmentPropertiesPage} />
      <Route path="/new_development_property/:id" component={NewDevelopmentProperty} />
      <Route path="/rural_lands" component={RuralLandsPage} />
      <Route path="/rural_land/:id" component={RuralLand} />
      <Route path="/urban_lands" component={UrbanLandsPage} />
      <Route path="/urban_land/:id" component={UrbanLand} />
      <Route path="/buildings" component={BuildingsPage} />
      <Route path="/building/:id" component={Building} />
      <Route path="/investments" component={InvestmentsPage} />
      <Route path="/investment/:id" component={Investment} />
      <Route path="/offer" exact component={SuplyOpsPage} />
      <Route path="/offer/:id" component={SuplyOp} />
      <Route path="/demand" exact component={DemandOpsPage} />
      <Route path="/demand/:id" component={DemandOp} />

      <Route path="/market" component={MarketPage} />
      <Route path="/register" component={RegisterPage} />

      <Route path="/" component={LandingPage} />

    </Switch>
  </Router>,
  document.getElementById("root")
);
